import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $createParagraphNode, $insertNodes, COMMAND_PRIORITY_EDITOR, createCommand } from "lexical";
import { $createLayoutContainerNode, LayoutContainerNode } from "./layout-container-node";
import { $createLayoutItemNode, LayoutItemNode } from "./layout-item-node";

/** Command to insert a multi-column layout (payload is a grid-template-columns value). */
export var INSERT_LAYOUT_COMMAND = createCommand("INSERT_LAYOUT_COMMAND");

/** Registers the insert-layout command handler. */
export function LayoutPlugin() {
  var _useLexicalComposerCo = useLexicalComposerContext(),
    _useLexicalComposerCo2 = _slicedToArray(_useLexicalComposerCo, 1),
    editor = _useLexicalComposerCo2[0];
  useEffect(function () {
    if (!editor.hasNodes([LayoutContainerNode, LayoutItemNode])) return undefined;
    return editor.registerCommand(INSERT_LAYOUT_COMMAND, function (template) {
      editor.update(function () {
        var container = $createLayoutContainerNode(template);
        var count = template.split(/\s+/).filter(Boolean).length;
        for (var index = 0; index < count; index += 1) {
          container.append($createLayoutItemNode().append($createParagraphNode()));
        }
        $insertNodes([container]);
      });
      return true;
    }, COMMAND_PRIORITY_EDITOR);
  }, [editor]);
  return null;
}